/**
 * xử lý khi click ra ngoài
 *
 */
export const clickOutDirective = {
    mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
            if (!(el == event.target || el.contains(event.target))) {
              binding.value();
            }
          };
          document.addEventListener('click', el.clickOutsideEvent,true);
    },
    beforeUnmount(el) {
        document.removeEventListener('click', el.clickOutsideEvent,true);
    },
}